import { SlideClassification } from "pwapi";

import { SagaAction } from "utils/asyncActions";

import {
  SLIDE_CLASSIFICATION_FAILURE,
  SLIDE_CLASSIFICATION_REQUEST,
  SLIDE_CLASSIFICATION_SUCCESS,
  SPECIMEN_CLASSIFICATION_SUCCESS,
} from "../actions/constants";

export interface ClassificationState {
  [slide_id: number]: SlideClassification | undefined;
}

const initialState: ClassificationState = {};

const classificationReducer = (
  state: ClassificationState = initialState,

  // TODO: SagaAction of this needs to be typed better with generics

  action: SagaAction
): ClassificationState => {
  switch (action.type) {
    case SPECIMEN_CLASSIFICATION_SUCCESS:
      const specimenClassification = action.payload?.response as
        | SlideClassification[]
        | undefined; // TODO: I should be able to know what's going to be in the payload
      const slideClassifications = Object.fromEntries(
        specimenClassification?.map((sc) => [sc.slide_id, sc]) || []
      );
      return {
        ...state,
        ...slideClassifications,
      };
    case SLIDE_CLASSIFICATION_REQUEST:
    case SLIDE_CLASSIFICATION_FAILURE:
      return {
        ...state,
        [action.args.slide_id]: undefined,
      };
    case SLIDE_CLASSIFICATION_SUCCESS:
      const slide_id = action.payload?.response?.slide_id as number;
      return {
        ...state,
        [slide_id]: action.payload?.response as SlideClassification,
      };

    // NOTE: In general I think these WIPE_*
    // ...   actions are code smells, but for now
    // ...   they stop stale classification in the store
    // TODO: We can't do this because hasLoaded will still be in the adjacent store
    // case WIPE_CASES:
    // case WIPE_CASE_DETAIL:
    //   return initialState;

    default:
      return state;
  }
};

export default classificationReducer;
